import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAward,
  faBell,
  faCalendarAlt,
  faClock,
  faEnvelopeOpenText,
  faPlayCircle,
  faVideo,
} from '@fortawesome/free-solid-svg-icons';

import { Reveal } from '../../../../components/Reveal/Reveal';
import { SectionHeader } from '../../../../components/SectionHeader/SectionHeader';

import ui from '../../../../styles/ui.module.css';
import st from './LearningTrajectory.module.css';

const steps = [
  {
    icon: faEnvelopeOpenText,
    title: 'Заявка и договор',
    text:
      'Оформляете заявку на обучение по вашей специальности. На указанную вами электронную почту в течение 5 дней поступит договор и реквизиты для оплаты доступа к курсу.',
  },
  {
    icon: faPlayCircle,
    title: 'Доступ к материалам',
    text:
      'В течение 3 дней после оплаты вы получаете полный доступ к материалам и видеолекциям.',
  },
  {
    icon: faBell,
    title: 'Итоговая аттестация',
    text:
      '1 раз в 3 недели в чате слушателей в MAX анонсируется дата итоговой аттестации в онлайн-формате.',
  },
  {
    icon: faAward,
    title: 'Удостоверение о повышении квалификации',
    text:
      'При условии наличия документов об образовании и успешном прохождении итоговой аттестации вы получаете удостоверение о повышении квалификации в РНИМУ им. Н. И. Пирогова.',
  },
];

export function LearningTrajectory() {
  return (
    <section className={`${ui.section} ${ui.sectionSeam} ${st.root}`}>
      <div className={ui.container}>
        <Reveal>
          <SectionHeader
            kicker="Как это устроено"
            title="Траектория обучения"
            subtitle="Как проходит обучение?"
          />
        </Reveal>

        <div className={st.timeline}>
          <div className={st.rail} aria-hidden="true" />

          <ol className={st.list}>
            {steps.map((step, index) => (
              <Reveal key={step.title} delay={Math.min(0.06 + index * 0.05, 0.22)}>
                <li className={st.item}>
                  <div className={st.nodeWrap}>
                    <span className={st.node}>
                      <span className={st.nodeInner}>
                        <FontAwesomeIcon icon={step.icon} className={st.nodeIcon} aria-hidden="true" />
                      </span>
                    </span>
                  </div>

                  <div className={`${ui.card} ${st.card}`}>
                    <div className={st.stepMeta}>
                      <span className={st.stepBadge}>Шаг {index + 1}</span>
                    </div>
                    <h3 className={st.stepTitle}>{step.title}</h3>
                    <p className={st.stepText}>{step.text}</p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>

          <Reveal delay={0.24}>
            <div className={`${ui.card} ${st.attestationBanner}`}>
              <div className={st.attestationBadge}>Ближайшая дата</div>
              <h3 className={st.attestationTitle}>Итоговая аттестация</h3>
              <p className={st.attestationText}>
                Следующая итоговая аттестация пройдёт в формате онлайн-вебинара на платформе MTS-link.
              </p>
              <div className={st.attestationMeta}>
                <span className={st.attestationMetaItem}>
                  <FontAwesomeIcon icon={faCalendarAlt} aria-hidden="true" />
                  29.10.2026
                </span>
                <span className={st.attestationMetaItem}>
                  <FontAwesomeIcon icon={faClock} aria-hidden="true" />
                  18:00 (МСК)
                </span>
                <span className={st.attestationMetaItem}>
                  <FontAwesomeIcon icon={faVideo} aria-hidden="true" />
                  MTS-link
                </span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
